import http from "../utils/request";

export function institution(){
    return http({
        url:'/sys/operations/page',
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 1000,
            id: "",
        }
    })
}

export function getOperations(){
    return http({
        url:'/sys/operations/page',
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 1000,
            id: "",
        }
    })
}

export function getChannels(){
    return http({
        url:'/sys/channels/page',
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 1000,
            id: "",
        }
    })
}
//sys/mechanism/list
export function getList(url = '/sys/mechanism/list'){
    return http({
        url: url,
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 1000,
            id: "",
        }
    })
}

export function getCompanies(){
    return http({
        url:'/sys/companies/page',
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 100000,
            id: "",
        }
    })
}
// 等级设置
export function getVipLeve(){
    return http({
        url:'/sys/sluserviplevel/page',
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 100000,
            id: "",
        }
    })
}

//获取page
export const pageList = (url) => {
    return http({
        url: url,
        method:'get',
        params:{
            order: "",
            orderField: "",
            page: 1,
            limit: 100000,
            id: "",
        }
        
    })
}

export const getReport = (data = {}) =>{
    return http({
        url:'/sys/report/adverTotal',
        method:'get',
        params:{
            end: data.end,
            start: data.start
        }
    })

}

export const tMessageNotification = data =>{
    return request({
      url:'/tMessageNotification/upload',
      method: 'POST',
      data,
      headers: {'Content-Type': 'application/json'},
    })
  }
  
